import { Component } from "react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen flex-col items-center justify-center bg-ink px-6 text-center">
                    <p className="font-mono text-[13px] tracking-[0.2em] text-accent">
                        BUILDEASE — SYSTEM NOTE
                    </p>
                    <h1 className="mt-6 text-2xl font-light text-white">
                        Something went off-plan.
                    </h1>
                    <button
                        type="button"
                        data-testid="error-reload-button"
                        onClick={() => window.location.reload()}
                        className="mt-8 bg-accent px-6 py-3 text-sm font-medium text-white"
                    >
                        Reload
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
